import { Box } from '@mui/material';
import usePageTitle from 'hooks/usePageTitle';
import Tabs, { ITab } from 'DesignSystem/Primitives/Tabs/Tabs';
import React, { FC } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';

type TabType = 'active' | 'archived';

const PRODUCT_TABS: ITab[] = [
  {
    key: 'active',
    label: 'Products',
  },
  {
    key: 'archived',
    label: 'Archived products',
  },
];

const ProductLayout: FC = () => {
  usePageTitle('Product pages');
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const selectedTab: TabType = pathname.split('/')[2] as TabType;

  const handleChangeTab = (tab: string) => {
    navigate(`/products/${tab}`);
  };

  return (
    <PageContainer>
      <PageTitle title="Product pages" />

      <Box mt={3} mb={1}>
        <Tabs tabs={PRODUCT_TABS} selectedTab={selectedTab} onChange={handleChangeTab} />
      </Box>

      <Outlet />
    </PageContainer>
  );
};

export default ProductLayout;
